var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { Year } from '@/models/Year';
import { DateTime } from 'luxon';
import ErrorHandler from '@/support/ErrorHandler';
let AddYearDialog = class AddYearDialog extends Vue {
    constructor() {
        super(...arguments);
        this.year = new Year();
        this.modal = false;
    }
    mounted() { }
    close() {
        this.$emit('input', false);
        this.clear();
    }
    calculateYearEnd() {
        if (this.year.starts_at && this.year.starts_at.length) {
            this.year.ends_at = DateTime.fromSQL(this.year.starts_at)
                .plus({ years: 1 })
                .toFormat('yyyy-LL-dd');
        }
    }
    create() {
        this.year
            .create()
            .then((year) => {
            this.$emit('yearCreated');
            this.$emit('input', false);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        this.clear();
    }
    clear() {
        this.year = new Year();
    }
};
AddYearDialog = __decorate([
    Component({
        components: {
            DataTable,
        },
    })
], AddYearDialog);
export default AddYearDialog;
